import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { CertificateRecord } from './certificate-record';

export class UserCourseCertificateStateModel extends EntityStateModel<CertificateRecord> {}
